import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { DepartmentDialogBoxComponent } from '../department-dialog-box/department-dialog-box.component';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent implements OnInit {
 displayedColumns = ['DeptCode', 'DeptName'];
  DepartmentForm: FormGroup;
  DepartmentList: any;
  DepartmentSearchForm;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  sortedData
  SessionNo: any;
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getDepartmentData();
    this.DepartmentSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.DepartmentList = [];
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['SearchString'] = this.DepartmentSearchForm.value['SearchString'];
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getDeptData(payload).subscribe(
      (res) => {
        if(res.status){
          this.DepartmentList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.DepartmentList = [];
        this.totalItems = 0
        }
       
        }, (ERROR: HttpErrorResponse) => {
        this.DepartmentList = [];
        this.totalItems = 0
      });
    },1000)
   
 
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getDepartmentData();
  }
  getDepartmentData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getDeptData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.DepartmentList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
        this.totalItems = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.DepartmentList = [];
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(DepartmentDialogBoxComponent, {
      width: '35%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getDepartmentData();
      this.DepartmentSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k) {
    const dialogRef = this.dialog.open(DepartmentDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getDepartmentData();
      this.DepartmentSearchForm.controls['SearchString'].setValue('');
    });
  }
  deleteData(k) {
    const dialogRef = this.dialog.open(DepartmentDialogBoxComponent, {
      width: '35%',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getDepartmentData();
      this.DepartmentSearchForm.controls['SearchString'].setValue('');
    });
  }


}
